import { Fragment } from "react";
import { motion } from "framer-motion";
import useWindowWidth from "../../hooks/useWindowWidth";
import LazyLoadingImg from "../Components/LazyLoadingImg";

const MotionSwitch = ({
  isMobile,
  as = "div",
  className,
  children,
  initial,
  inView,
  transition,
  ...rest
}) => {
  const Tag = as;
  if (!isMobile) {
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }
  const MotionTag = motion[as] ?? motion.div;
  return (
    <MotionTag
      className={className}
      initial={initial}
      whileInView={inView}
      viewport={{ once: true, amount: 0.45, margin: "0px 0px -10% 0px" }}
      transition={transition ?? { duration: 0.6, ease: "easeOut" }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default function ProjectOverview() {
  const width = useWindowWidth();
  const isMobile = width <= 600;

  return (
    <Fragment>
      <div
        className="container-fluid a2-bg-color-1 horizontal-padding"
        style={{ position: "relative", zIndex: "9" }}
      >
        <div className="row pb-5 mx-0">
          <div className="col-lg-6 col-md-6 col-12 px-0">
            <MotionSwitch
              isMobile={isMobile}
              as="h2"
              className="a2-font-3 mb-3"
              initial={{ opacity: 0, y: -40 }}
              inView={{ opacity: 1, y: 0 }}
            >
              Project Overview
            </MotionSwitch>

            <ul className="a2-font-ul-4">
              <MotionSwitch
                isMobile={isMobile}
                as="li"
                className="mb-3"
                initial={{ opacity: 0, x: -50 }}
                inView={{ opacity: 1, x: 0 }}
              >
                AddressTwo, a CRM software for all type of businesses, acts as a
                dedicated assistant for managing contacts, leads, and sales
                priorities. Affordable and user-friendly, it simplifies
                marketing and enhances customer relationships.
              </MotionSwitch>
              <MotionSwitch
                isMobile={isMobile}
                as="li"
                className="mb-3"
                initial={{ opacity: 0, x: 50 }}
                inView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
              >
                In response to client needs, we aimed to boost the scalability
                of their CRM system, prioritizing security, technology
                innovation, and sticking to industry best practices.
              </MotionSwitch>

              <MotionSwitch
                isMobile={isMobile}
                as="li"
                className="mb-3"
                initial={{ opacity: 0, x: -50 }}
                inView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
              >
                Challenges included migrating features, updating outdated
                technology, and addressing performance issues due to increased
                user numbers. It provides a streamlined solution, ensuring
                efficiency, security, and growth for small businesses.
              </MotionSwitch>
            </ul>
          </div>

          <div className="col-lg-6 col-md-6 col-12 px-0">
            <MotionSwitch
              isMobile={isMobile}
              initial={{ opacity: 0, y: 50 }}
              inView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="w-100 h-100 d-flex justify-content-center align-items-center"
            >
              <LazyLoadingImg
                src="/images/a2-portfolio-overview.png"
                alt="a2-portfolio-overview"
                className="img-fluid"
              />
            </MotionSwitch>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
